import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import QuoteFormPage from "@/pages/QuoteFormPage";
import QuoteViewPage from "@/pages/QuoteViewPage";
import ProductDatasheetPage from "@/pages/ProductDatasheetPage";
import UsersPage from "@/pages/UsersPage";
import ProductsPage from "@/pages/ProductsPage";
import CustomersPage from "@/pages/CustomersPage";
import PackingListsPage from "@/pages/PackingListsPage";
import PackingListFormPage from "@/pages/PackingListFormPage";
import PackingListViewPage from "@/pages/PackingListViewPage";
import AppLayout from "@/components/AppLayout";

const Protected = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <AppLayout>{children}</AppLayout>;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
            <Route path="/" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/quotes/new" element={<Protected><QuoteFormPage /></Protected>} />
            <Route path="/quotes/:id/edit" element={<Protected><QuoteFormPage /></Protected>} />
            <Route path="/quotes/:id" element={<Protected><QuoteViewPage /></Protected>} />
            <Route path="/products" element={<Protected><ProductsPage /></Protected>} />
            <Route path="/packing-lists" element={<Protected><PackingListsPage /></Protected>} />
            <Route path="/packing-lists/new" element={<Protected><PackingListFormPage /></Protected>} />
            <Route path="/packing-lists/:id/edit" element={<Protected><PackingListFormPage /></Protected>} />
            <Route path="/packing-lists/:id" element={<Protected><PackingListViewPage /></Protected>} />
            <Route path="/customers" element={<Protected adminOnly><CustomersPage /></Protected>} />
            <Route path="/products/:id/datasheet" element={<Protected><ProductDatasheetPage /></Protected>} />
            <Route path="/users" element={<Protected adminOnly><UsersPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
